import { Dispatch, SetStateAction } from 'react';

import { P1, P2 } from '../../../styles/FontStyles';
import { VirtualOfficePlan } from './VirtualOfficePlan';
import { Button } from '../Button/Button';
import { useAppSelector } from '../../../app/hooks';

interface VirtualOfficeSelectedPlanProps {
  setStep: Dispatch<SetStateAction<number>>;
  setSelected: Dispatch<SetStateAction<number>>;
  selected: any;
  buttonText: string;
}

export const VirtualOfficeSubscription = ({
  selected,
  setSelected,
  setStep,
  buttonText
}: VirtualOfficeSelectedPlanProps) => {
  const { licences } = useAppSelector((state) => state.settings);
  return (
    <div>
      <VirtualOfficePlan
        selected={selected}
        setSelected={setSelected}
        licences={licences}
      />

      <P1 m='40px 0'>
        It is highly advised to select a multi-year access and{' '}
        <b>avoid the big risk</b> of losing the benefits in case you do not
        renew the Back-Office in time.
      </P1>

      <Button
        disabled={!selected}
        onClick={() => {
          setStep(2);
          setSelected(selected);
        }}>
        {buttonText}
      </Button>
    </div>
  );
};
